const shopAdd = () => import('@/views/main/shop/add/add.vue')
export default {
  path: '/main/shop/add',
  name: 'shopAdd',
  component: shopAdd,
  children: []
}
